import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Box } from '@mui/material';

// import strapi_dark from '~/content/images/websites/logos/Strapi.vertical.logo.dark.svg';
// import strapi_light from '~/content/images/websites/logos/Strapi.vertical.logo.light.svg';

import figma_dark from '~/content/images/websites/logos/figma_black.webp';
import figma_light from '~/content/images/websites/logos/figma_light.webp';

import stripe from '~/content/images/websites/logos/Stripe wordmark - blurple.svg';

import remix_light from '~/content/images/websites/logos/1200x627Lightsvg.svg';
import remix_dark from '~/content/images/websites/logos/1200x627Darksvg.svg';

import payload_light from '~/content/images/websites/logos/payload_light.svg';
import payload_dark from '~/content/images/websites/logos/payload_dark.svg';

import node_light from '~/content/images/websites/logos/nodejs_light.webp';
import node_dark from '~/content/images/websites/logos/nodejs_dark.webp';

import react2 from '~/content/images/websites/logos/react2.webp';

import { useTranslation } from 'react-i18next';

const Welcome = () => {
	let { t } = useTranslation(['websites']);
	const theme = useTheme();

	const GridItemHeadlineBlock = () => (
		<Box>
			<Typography
				component='h1'
				variant='h2'
				align={'center'}
				gutterBottom
				sx={{
					fontWeight: 900,
				}}
			>
				{t('welcome_Headline')}
			</Typography>

			<Typography variant='h6' component={'h2'} color='text.secondary' align={'center'}>
				{t('welcome_Subheadline')}
			</Typography>
		</Box>
	);

	// var wasm = theme.palette.mode === 'light' ? wasm_dark : wasm_light;
	// var strapi = theme.palette.mode === 'light' ? strapi_dark : strapi_light;
	var fimga = theme.palette.mode === 'light' ? figma_dark : figma_light;
	var remix = theme.palette.mode === 'light' ? remix_dark : remix_light;
	var payload = theme.palette.mode === 'light' ? payload_dark : payload_light;
	var node = theme.palette.mode === 'light' ? node_dark : node_light;

	const GridItemPartnersBlock = () => (
		<Box display='flex' flexWrap='wrap' justifyContent={'center'}>
			{[react2, node, remix, stripe, fimga, payload].map((item, i) => (
				<Box marginTop={2} marginRight={2} marginLeft={2} key={i}>
					<Box
						component='img'
						maxWidth={90}
						height={40}
						src={item}
						alt='Moderne Werkzeuge zur Webseiten programmierung und design'
						// sx={{
						// 	filter:
						// 		theme.palette.mode === 'dark'
						// 			? 'brightness(1) contrast(1)  invert(0)'
						// 			: 'brightness(1)',
						// }}
					/>
				</Box>
			))}
		</Box>
	);
	return (
		<Box>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Box width='100%' height='100%' display='flex' justifyContent={'center'}>
						<GridItemHeadlineBlock />
					</Box>
				</Grid>
				<Grid item xs={12}>
					<Box width='100%' height='100%' display='flex' justifyContent={'center'} mt={2}>
						<Typography
							variant={'body2'}
							align={'center'}
							color={'text.primary'}
							component={'h3'}
							// fontWeight='bold'
							// data-aos={'fade-up'}
						>
							{t('partner_description')}
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={12}>
					<Box width='100%' height='100%' display='flex' justifyContent={'center'}>
						<GridItemPartnersBlock />
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Welcome;
